import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Mainheader from "../../components/mainheader/Mainheader";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "../../components/footer/Footer";

import {
    getPageContent,
} from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";

import OrderFormPhone from "../../components/order/OrderFormPhone";

const OrderPhone = (props) => {
    const { hostLanguage, languageJson } = useLangContext();
    const [contentDetails, setContentDetails] = useState();
    const getAllPageContent = async () => {
        try {
            let apiRes = await getPageContent(hostLanguage);
            let responseData = await apiRes.json();
            if (responseData.res) {
                setContentDetails(responseData.data);
                // console.warn(responseData.data.header);
            } else {
                NotificationManager.error(responseData.msg, "", 2000);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getAllPageContent();
    }, [hostLanguage]);

    return (
        <div className="WebBody">
            <Mainheader />
            <div className="MainbBody">
                <div className="PricelistBanner">
                    <Container>
                    <Row>
                        <Col sm={12}>
                            <p>CleverDomizil</p>
                            <h3>Bestellformular</h3>
                        </Col>
                    </Row>
                    </Container>
                </div>
                <div className="PricelistBody">
                    <OrderFormPhone />
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default OrderPhone;